import React from 'react';
import './MainHeader.css';
import { injectIntl } from 'react-intl';
import netlogo from '../assets/images/sernet-bw.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { useMsal } from '@azure/msal-react';

const MainHeader = () => {

  const { instance } = useMsal();

  async function signOut() {
    const account = instance.getActiveAccount();
    const logoutRequest = {
      account
    }
    await instance.logoutRedirect(logoutRequest);
  }

  return(
    <div className="app-header d-flex flex-md-row flex-column px-md-4 px-3">
      <div className="site-id">
        <img className="test" src={netlogo} alt="Sernet - logo - Home page" />
      </div>
      <div className="user-details d-flex flex-row align-items-center ml-md-auto mb-4 mb-md-0">
        <button className="btn btn-primary" onClick={() => signOut()}>
          <FormattedMessage id="desktop.logout"/>
          <FontAwesomeIcon icon="door-open" />
        </button>
      </div>
  </div>
  );
};


export default injectIntl(MainHeader);
